var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelLogoPh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8906 24.9823H4.88682C3.17196 24.9823 1.77759 23.5656 1.77759 21.8233V10.1591C1.77759 8.41672 3.17196 7 4.88682 7H26.8906C28.6055 7 29.9999 8.41672 29.9999 10.1591V21.8233C29.9999 23.5656 28.6055 24.9823 26.8906 24.9823ZM4.88682 7.48601C3.43505 7.48601 2.25593 8.68402 2.25593 10.1591V21.8233C2.25593 23.2983 3.43505 24.4963 4.88682 24.4963H26.8906C28.3424 24.4963 29.5215 23.2983 29.5215 21.8233V10.1591C29.5215 8.68402 28.3424 7.48601 26.8906 7.48601H4.88682ZM14.3704 18.4199L14.3712 18.4185C14.6289 17.9682 14.8825 17.5251 15.1353 17.082C15.4042 16.6093 15.672 16.1357 15.9398 15.6621L15.9398 15.662C16.4485 14.7624 16.9574 13.8625 17.4744 12.9679C17.8451 12.3288 18.4 12.3336 18.7755 12.9825C19.1011 13.548 19.4187 14.1179 19.7363 14.6878L19.7364 14.6879C19.9974 15.1563 20.2584 15.6246 20.5239 16.0905C21.0105 16.9459 21.5009 17.7982 21.9913 18.6505C22.3757 19.3188 22.7602 19.987 23.1428 20.6566C23.712 21.6529 23.4728 22.0636 22.3296 22.0636H9.45258C9.31386 22.0636 9.17275 22.0636 9.03403 22.049C8.42175 21.9907 8.15866 21.5508 8.46241 21.0016C9.28277 19.5144 10.1175 18.037 10.9761 16.5741C11.3109 16.0006 11.8778 16.0613 12.2413 16.6834C12.5417 17.1979 12.8331 17.7165 13.1246 18.2352L13.1247 18.2354C13.2834 18.5177 13.442 18.8001 13.6022 19.0819C13.6377 19.145 13.6759 19.2044 13.7192 19.2716L13.7193 19.2717C13.7459 19.3131 13.7745 19.3575 13.8055 19.4075C13.9968 19.0728 14.1846 18.7445 14.3704 18.4199ZM14.0518 11.8112C14.0925 10.8101 13.2769 9.94254 12.27 9.91581C11.2559 9.88908 10.4307 10.6837 10.402 11.7189C10.3733 12.7371 11.1626 13.5828 12.1767 13.6241C13.1549 13.6629 14.0111 12.8343 14.0518 11.8112Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.77759,
    y1: 7,
    x2: 18.0762,
    y2: 32.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#C8C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DAEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelLogoPh);
export default __webpack_public_path__ + "static/media/channel_logo_ph.f6494a889ca1ae3809ed3427a0407fe1.svg";
export { ForwardRef as ReactComponent };